// PhoneInput.jsx
import React, { useEffect, useState } from "react";
import PhoneInputBase from "react-phone-number-input";
import "react-phone-number-input/style.css";
import styles from "./PhoneInput.module.css";

const getLocaleCountry = () => {
  try {
    const locale = navigator.language || navigator.languages?.[0];
    const region = locale?.split("-")[1];
    return region?.toUpperCase() || "US";
  } catch {
    return "US";
  }
};

const PhoneInput = ({
  id = "phone",
  label = "Mobile number",
  required = false,
  value,
  onChange,
  className = "",
}) => {
  // Synchronous default so a country + dial code is visible on first paint —
  // never blank while the IP lookup is still in flight.
  const [country, setCountry] = useState(getLocaleCountry());

  useEffect(() => {
    let cancelled = false;
    fetch("https://ipapi.co/json")
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && data?.country_code) {
          setCountry(data.country_code);
        }
      })
      .catch(() => {
        // keep the locale-based default on failure
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={[styles.field, className].filter(Boolean).join(" ")}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
      )}
      <PhoneInputBase
        id={id}
        international
        defaultCountry={country}
        value={value}
        onChange={onChange}
        className={styles.phoneInput}
      />
    </div>
  );
};

export default PhoneInput;
